// extracted by mini-css-extract-plugin
export default {"htmlText":"styles_htmlText__+PWHN"};